<template>
  <div class="receive-chart-wrap">
    <div class="handle-wrapper">
      <div class="handle-left">
        <!-- <Select
          placeholder="搜索客户"
          v-model="selectedCustomer"
          label-in-value
          clearable
          filterable
          :remote-method="chooseCustomer"
          @on-change="changeCustomer"
          style="width: 220px; margin-right: 30px"
        >
          <Option
            v-for="item in customersSimple"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select> -->
        <!-- <Select
          placeholder="筛选公司"
          v-model="company"
          label-in-value
          clearable
          @on-change="chooseCompany"
          style="width: 180px; margin-right: 30px"
        >
          <Option
            v-for="item in companyList"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select> -->
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 200px"
          v-model="month"
          @on-change="changeDate"
        />
      </div>
      <div class="handle-right"></div>
    </div>
    <div class="chart-wrap">
      <div class="receive-chart">
        <div id="receiveDailyChart" style="width: 1300px; height: 400px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
} from "echarts/components";
import { LabelLayout, UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent,
]);
import _ from "lodash";
import dayjs from "dayjs";

export default {
  name: "OutStoreStat",
  data() {
    return {
      receiveDailyChart: null,
      receiveDailyChartOption: null,
      limit: 20,
      page: 0,
      selectedCustomer: null,
      filterQuery: {
        startAt: null,
        endAt: null,
        groupBy: "day",
      },
      invalid: null,
      company: null,
      chartDateArray: [],
      receiveChartData: {
        preTaxSalesAmount: [],
        salesAmount: [],
        tax: [],
        volDiff: [],
        volOutFactory: [],
        volReceived: [],
        totalAmount: [],
      },
      month: null,
    };
  },
  computed: mapState({
    companyList: (state) => state.company.companyList,
    user: (state) => state.auth.currentUser,
  }),
  methods: {
    ...mapActions({
      getOutStoreStat: "outStore/getOutStoreStatAction",
    }),
    // numDeal(e) {
    //   return e.toLocaleString();
    // },
    // typeToTextMethod(e) {
    //   return typeToText[e];
    // },
    async loadReceiveChart(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      this.receiveChartData = {
        preTaxSalesAmount: [],
        salesAmount: [],
        tax: [],
        volDiff: [],
        volOutFactory: [],
        volReceived: [],
        totalAmount: [],
      };
      try {
        const data = await this.getOutStoreStat(this.filterQuery);
        const outStoreStat = data.outStoreStat;
        const startAt = dayjs(this.filterQuery.startAt);
        const endAt = dayjs(this.filterQuery.endAt);
        const daysCount = endAt.diff(startAt, "day") + 1;
        if (this.chartDateArray.length > 1) {
          this.chartDateArray = this.chartDateArray.splice(
            this.chartDateArray.length
          );
        }
        for (let i = 0; i < daysCount; i++) {
          const currentDate = startAt.add(i, "day");
          this.chartDateArray.push(dayjs(currentDate).format("M/D"));
          const currentDateText = dayjs(currentDate).format("YYYY-MM-DD");
          const outStoreData = outStoreStat.find((v) => {
            const receiveDate = dayjs()
              .year(v._id.year)
              .month(v._id.month - 1)
              .date(v._id.day);
            const receiveDateText = dayjs(receiveDate).format("YYYY-MM-DD");
            return receiveDateText === currentDateText;
          });

          if (outStoreData) {
            this.receiveChartData.salesAmount.push(
              (outStoreData.salesAmount / 10000).toFixed(2)
            );
            this.receiveChartData.preTaxSalesAmount.push(
              (outStoreData.preTaxSalesAmount / 10000).toFixed(2)
            );
            this.receiveChartData.tax.push(
              (outStoreData.tax / 10000).toFixed(2)
            );
            this.receiveChartData.volDiff.push(
              (outStoreData.volDiff / 10000).toFixed(2)
            );
            this.receiveChartData.volOutFactory.push(
              (outStoreData.volOutFactory / 10000).toFixed(2)
            );
            this.receiveChartData.volReceived.push(
              (outStoreData.volReceived / 10000).toFixed(2)
            );
            let totalAmount = null;
            for (const key in outStoreData) {
              if (key !== "_id" && key !== "count") {
                totalAmount = totalAmount + outStoreData[key];
              }
            }
            this.receiveChartData.totalAmount.push(
              (totalAmount / 10000).toFixed(2)
            );
          } else {
            this.receiveChartData.salesAmount.push(0);
            this.receiveChartData.preTaxSalesAmount.push(0);
            this.receiveChartData.tax.push(0);
            this.receiveChartData.volDiff.push(0);
            this.receiveChartData.volOutFactory.push(0);
            this.receiveChartData.volReceived.push(0);
            this.receiveChartData.totalAmount.push(0);
          }
        }
        this.receiveDailyChartOption.xAxis[0].data = this.chartDateArray;
        this.receiveDailyChartOption.series[0].data =
          this.receiveChartData.totalAmount;
        this.receiveDailyChartOption.series[1].data =
          this.receiveChartData.preTaxSalesAmount;
        this.receiveDailyChartOption.series[2].data =
          this.receiveChartData.salesAmount;
        this.receiveDailyChartOption.series[3].data = this.receiveChartData.tax;
        this.receiveDailyChartOption.series[4].data =
          this.receiveChartData.volDiff;
        this.receiveDailyChartOption.series[5].data =
          this.receiveChartData.volOutFactory;
        this.receiveDailyChartOption.series[6].data =
          this.receiveChartData.volReceived;
        this.reloadChart();
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
      }
    },
    async chooseCustomer(query) {
      this.page = 0;
      if (query !== "") {
        this.customerLoading = true;
        await this.getCustomerSimpleList({ name: query });
        this.customerLoading = false;
      }
    },
    changeCustomer() {
      if (this.selectedCustomer) {
        this.filterQuery.customer = this.selectedCustomer;
        this.loadReceiveChart();
      }
    },
    async chooseCompany(company) {
      if (company) {
        this.filterQuery.company = company.value;
      } else {
        delete this.filterQuery.company;
      }
      await this.loadReceiveChart();
    },
    changeDate(e) {
      const date = new Date(e);
      this.filterQuery.startAt = dayjs(
        new Date(date.getFullYear(), date.getMonth(), 1)
      ).format("YYYY-MM-DD");
      this.filterQuery.endAt = dayjs(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
      ).format("YYYY-MM-DD");
      this.loadReceiveChart();
    },
    drawChart() {
      this.receiveDailyChart = echarts.init(
        document.getElementById("receiveDailyChart")
      );
      this.receiveDailyChartOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["金额", "销售额", "税", "数量差异", "厂内实发", "客户实收"],
        },
        grid: {
          top: "20%",
          right: "5%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            name: "日",
            type: "category",
            axisLabel: {
              interval: 0,
            },
            data: this.chartDateArray,
          },
        ],
        yAxis: [
          {
            name: "出库单统计(W)",
            type: "value",
          },
        ],
        series: [
          {
            name: "总计",
            type: "bar",
            barWidth: 20,
            label: {
              show: true,
              position: "top",
              formatter: "{c}",
              color: "#000",
            },
            itemStyle: {
              color: "rgba(128, 128, 128, 0)", // 设置背景颜色为透明
            },
            barGap: "-100%",
            data: this.receiveChartData.totalAmount,
          },
          {
            name: "金额",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.preTaxSalesAmount,
          },
          {
            name: "销售额",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.salesAmount,
          },
          {
            name: "税",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.tax,
          },
          {
            name: "数量差异",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.volDiff,
          },
          {
            name: "厂内实发",
            type: "bar",
            barWidth: 20,
            stack: "Ad",
            data: this.receiveChartData.volOutFactory,
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "客户实收",
            type: "bar",
            barWidth: 20,
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.volReceived,
          },
        ],
      };
    },
    reloadChart() {
      this.receiveDailyChart.setOption(this.receiveDailyChartOption, {
        notMerge: true,
      });
    },
  },
  async created() {
    let date = new Date();
    this.filterQuery.startAt = dayjs(new Date().setDate(1)).format(
      "YYYY-MM-DD"
    );
    this.month = dayjs(new Date().setDate(1)).format("YYYY-MM-DD");
    this.filterQuery.endAt = dayjs(
      new Date(date.getFullYear(), date.getMonth() + 1, 0)
    ).format("YYYY-MM-DD");
    this.loadReceiveChart();
    // await this.getCompanyList({ limit: 99 });
  },
  mounted() {
    this.drawChart();
  },
};
</script>
<style lang="stylus" scoped></style>